// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {deleteFavorite as deleteFavoriteApi} from '../../../../shared/repositories';
import {getStore} from '../../../../store-factory';
import {readFavorites} from './read-favorites';

export const deleteFavorite = favoriteId =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());
        const userId = getStore().getState().user.details.id;

        try {

            await deleteFavoriteApi(userId, favoriteId);
            await readFavorites(userId)(dispatch);

        } catch (error) {

            await readFavorites(userId)(dispatch);
            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/components/favorites/action-creators/delete-favorite.js